import * as yup from 'yup';
import ModuleBootstrapper from '../common/ModuleBootstrapper/ModuleBootstrapper';

const config = {
    name: 'interestRegistrations',
    actions: [
        { type: 'request', name: 'getAll' },
        { type: 'request', name: 'getOne' },
        { type: 'request', name: 'edit' },
        { type: 'request', name: 'delete' },
        { type: 'request', name: 'updateStatus' },
        { type: 'request', name: 'runLottery' },
        { type: 'request', name: 'getSelectedEmails' }
    ],
    endpoints: {
        interestRegistrations: '/interest-registrations',
        interestRegistration: '/interest-registrations/[id]',
        updateStatus: '/interest-registrations/[id]/status',
        runLottery: '/interest-registrations/campaign/[campaignId]/lottery',
        selectedEmails: '/interest-registrations/campaign/[campaignId]/selected-emails'
    },
    defaults: {},
    validations: {
        interestRegistration: yup.object().shape({
            status: yup.string().required("Statusul este obligatoriu"),
        })
    }
}

const Config = {
    Actions: ModuleBootstrapper.getActions(config.name, config.actions),
    Endpoints: config.endpoints,
    Defaults: config.defaults,
    Validations: config.validations,
    ...ModuleBootstrapper.getUtils(),
}

export default Config;
